// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Tab styles ─────────────────────────────────────────────── */
.tab-content-pad {
  padding: 0 4px;
}

:host ::ng-deep .mat-mdc-tab-labels {
  border-bottom: 2px solid #e0e0e0;
}

:host ::ng-deep .mat-mdc-tab .mdc-tab__text-label {
  font-weight: 600;
  font-size: 0.88rem;
}

.tab-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  position: relative;
  top: 2px;
}

/* ── Page header ────────────────────────────────────────────── */
.stats-page-header h1 {
  color: #212529;
  font-weight: 600;
}

.stats-chevron-blue {
  color: #0066B2;
}

.stats-title-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  position: relative;
  top: 2px;
}

/* ── Card header — blue, mirrors dashboard candidates-card-header ── */
.stats-card-header {
  background: #0066B2 !important;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
  border-bottom: none !important;
}

.stats-header-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  position: relative;
  top: 2px;
  opacity: 0.9;
}

/* ── Bootstrap card overrides ──────────────────────────────── */
:host ::ng-deep .card {
  border-radius: 8px !important;
  overflow: hidden;
}

:host ::ng-deep .card-header {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

/* ── Filter row ─────────────────────────────────────────────── */
.stats-filter-row {
  display: flex;
  align-items: flex-end;
  gap: 0;
  flex-wrap: wrap;
}

.stats-filter-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 16px;
  border-right: 1px solid #e0e0e0;
}

.stats-filter-field:first-child {
  padding-left: 0;
}

.stats-filter-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #888888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0;
  white-space: nowrap;
}

.stats-filter-field .form-control {
  min-width: 150px;
  border-radius: 6px;
}

.stats-filter-separator {
  /* visual gap between date pickers handled by border-right on field */
}

.stats-filter-actions {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding-left: 20px;
}

.stats-filter-btn {
  height: 31px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 14px;
  border-radius: 6px !important;
  font-size: 0.82rem;
  white-space: nowrap;
}

.stats-btn-icon {
  font-size: 15px !important;
  height: 15px !important;
  width: 15px !important;
  line-height: 1;
}

/* ── KPI section label ──────────────────────────────────────── */
.kpi-section {
  margin-bottom: 16px;
}

.kpi-section__label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #aaaaaa;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.kpi-section__label::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #eeeeee;
}

/* ── KPI grids — explicit column counts ─────────────────────── */
.kpi-grid {
  display: grid;
  gap: 12px;
}

/* 4 equal columns — job summary row */
.kpi-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

/* 4 equal columns — token totals/averages row */
.kpi-grid-4-tokens {
  grid-template-columns: repeat(4, 1fr);
}

/* 3 equal columns — recent activity row */
.kpi-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

/* fallback general grid used by Nora tab */
.kpi-grid-auto {
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

/* ── KPI Card ────────────────────────────────────────────────── */
.kpi-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  min-width: 0; /* prevent grid blowout */
}

.kpi-card__content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.kpi-card__label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #999999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-card__value {
  font-size: 1.55rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kpi-card__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.55;
  margin-left: 8px;
}

.kpi-card__icon mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

/* ── KPI Color variants — Chevron palette ───────────────────── */
.kpi-blue   { color: #0066B2; }
.kpi-green  { color: #2e7d32; }
.kpi-orange { color: #e65100; }
.kpi-purple { color: #6a1b9a; }
.kpi-red    { color: #c62828; }

/* ── Conversation dialog styles (used by ConversationDialogComponent) ── */
.conversation-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
}

.message {
  padding: 10px 14px;
  border-radius: 8px;
  max-width: 90%;
}

.user-message {
  align-self: flex-start;
  background-color: #e3f2fd;
  border: 1px solid #bbdefb;
}

.assistant-message {
  align-self: flex-end;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
}

.message-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 12px;
}

.message-time {
  color: #999;
  font-size: 11px;
}

.message-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-statistics/ai-statistics.component.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA,kEAAkE;AAClE;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA,uEAAuE;AACvE;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,qBAAqB;EACrB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,OAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,qCAAqC;AACvC;;AAEA,gDAAgD;AAChD;EACE,qCAAqC;AACvC;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;AACvC;;AAEA,2CAA2C;AAC3C;EACE,2DAA2D;AAC7D;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,yCAAyC;EACzC,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,kEAAkE;AAClE,cAAc,cAAc,EAAE;AAC9B,cAAc,cAAc,EAAE;AAC9B,cAAc,cAAc,EAAE;AAC9B,cAAc,cAAc,EAAE;AAC9B,cAAc,cAAc,EAAE;;AAE9B,2EAA2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["/* ── Tab styles ─────────────────────────────────────────────── */\n.tab-content-pad {\n  padding: 0 4px;\n}\n\n:host ::ng-deep .mat-mdc-tab-labels {\n  border-bottom: 2px solid #e0e0e0;\n}\n\n:host ::ng-deep .mat-mdc-tab .mdc-tab__text-label {\n  font-weight: 600;\n  font-size: 0.88rem;\n}\n\n.tab-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  position: relative;\n  top: 2px;\n}\n\n/* ── Page header ────────────────────────────────────────────── */\n.stats-page-header h1 {\n  color: #212529;\n  font-weight: 600;\n}\n\n.stats-chevron-blue {\n  color: #0066B2;\n}\n\n.stats-title-icon {\n  font-size: 22px;\n  width: 22px;\n  height: 22px;\n  position: relative;\n  top: 2px;\n}\n\n/* ── Card header — blue, mirrors dashboard candidates-card-header ── */\n.stats-card-header {\n  background: #0066B2 !important;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 0.9rem;\n  border-bottom: none !important;\n}\n\n.stats-header-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  position: relative;\n  top: 2px;\n  opacity: 0.9;\n}\n\n/* ── Bootstrap card overrides ──────────────────────────────── */\n:host ::ng-deep .card {\n  border-radius: 8px !important;\n  overflow: hidden;\n}\n\n:host ::ng-deep .card-header {\n  border-top-left-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n\n/* ── Filter row ─────────────────────────────────────────────── */\n.stats-filter-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 0;\n  flex-wrap: wrap;\n}\n\n.stats-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 0 16px;\n  border-right: 1px solid #e0e0e0;\n}\n\n.stats-filter-field:first-child {\n  padding-left: 0;\n}\n\n.stats-filter-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #888888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 0;\n  white-space: nowrap;\n}\n\n.stats-filter-field .form-control {\n  min-width: 150px;\n  border-radius: 6px;\n}\n\n.stats-filter-separator {\n  /* visual gap between date pickers handled by border-right on field */\n}\n\n.stats-filter-actions {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding-left: 20px;\n}\n\n.stats-filter-btn {\n  height: 31px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 14px;\n  border-radius: 6px !important;\n  font-size: 0.82rem;\n  white-space: nowrap;\n}\n\n.stats-btn-icon {\n  font-size: 15px !important;\n  height: 15px !important;\n  width: 15px !important;\n  line-height: 1;\n}\n\n/* ── KPI section label ──────────────────────────────────────── */\n.kpi-section {\n  margin-bottom: 16px;\n}\n\n.kpi-section__label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #aaaaaa;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.kpi-section__label::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #eeeeee;\n}\n\n/* ── KPI grids — explicit column counts ─────────────────────── */\n.kpi-grid {\n  display: grid;\n  gap: 12px;\n}\n\n/* 4 equal columns — job summary row */\n.kpi-grid-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* 4 equal columns — token totals/averages row */\n.kpi-grid-4-tokens {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* 3 equal columns — recent activity row */\n.kpi-grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n/* fallback general grid used by Nora tab */\n.kpi-grid-auto {\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n}\n\n/* ── KPI Card ────────────────────────────────────────────────── */\n.kpi-card {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 14px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  min-width: 0; /* prevent grid blowout */\n}\n\n.kpi-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.kpi-card__label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #999999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kpi-card__value {\n  font-size: 1.55rem;\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kpi-card__icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.55;\n  margin-left: 8px;\n}\n\n.kpi-card__icon mat-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n/* ── KPI Color variants — Chevron palette ───────────────────── */\n.kpi-blue   { color: #0066B2; }\n.kpi-green  { color: #2e7d32; }\n.kpi-orange { color: #e65100; }\n.kpi-purple { color: #6a1b9a; }\n.kpi-red    { color: #c62828; }\n\n/* ── Conversation dialog styles (used by ConversationDialogComponent) ── */\n.conversation-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.message {\n  padding: 10px 14px;\n  border-radius: 8px;\n  max-width: 90%;\n}\n\n.user-message {\n  align-self: flex-start;\n  background-color: #e3f2fd;\n  border: 1px solid #bbdefb;\n}\n\n.assistant-message {\n  align-self: flex-end;\n  background-color: #f5f5f5;\n  border: 1px solid #e0e0e0;\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  font-size: 12px;\n}\n\n.message-time {\n  color: #999;\n  font-size: 11px;\n}\n\n.message-content {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
